jQuery(document).ready(function(){

    if($(window).width() >= 750) {
        jQuery('.postListing').owlCarousel({
        loop:true,
        margin:27,
        items:3.5,
        dots: false
        });
    }

    jQuery('.tabs .tabTitle').click(function(){
        var index = jQuery(this).index() + 1;
        jQuery('.tabs .tabTitle').removeClass('active');
        jQuery(this).addClass('active');

        jQuery('.tabText').hide();
        

        jQuery('.tabText.tab'+index).show();

    })
    
    if($(window).width() < 750) {
        jQuery('.reviewsListing').owlCarousel({
            loop:true,
            items:1,
            dots: true
          }); 

          jQuery('.reviewsBottomProducts').owlCarousel({
            loop:true,
            items:2.3,
            dots: false
          }); 

          jQuery('.instagramHolder .container').owlCarousel({
            loop:true,
            items:1.3,
            dots: false,
            margin:1
          }); 

          jQuery('.postListing').owlCarousel({
            loop:true,
            items:1.2,
            dots: false,
            margin:11,
          });
          
          


          jQuery('.newslContentHolder .newslTitle p').eq(1).text(jQuery('.newslContentHolder .newslTitle p').eq(1).text() + ' '  + jQuery('.newslContentHolder .newslTitle p').eq(2).text());
          jQuery('.newslContentHolder .newslTitle p').eq(2).remove();
     }       

});
/*
function capyInstaImages() { 
    console.log("div was handled");
    let i=0;
    while(i<=5) {
        $('.instagramHolder .inst'+i).attr('src',$('#rap__med__onclick__'+i+' #rap__med__insta-img img').attr('data-src'));
        $('.instagramHolder .div'+i+' a').attr('href',$('#rap__med__onclick__'+i).attr('href'));
        i++;
    }
}

const observer = new MutationObserver(function (mutations, mutationInstance) {
    if ($('#rap__med__onclick__0 #rap__med__insta-img img').length && $('#rap__med__onclick__0 #rap__med__insta-img img').attr('data-src').length) {
        capyInstaImages();
        mutationInstance.disconnect();
        $('#rap__med__insta').hide();
    }
});


observer.observe(document, {
    childList: true,
    subtree:   true
});*/